import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';

interface TabPanelProps {
  value: number;
  index: number;
  children: React.ReactNode;
}

const TabPanel: React.FC<TabPanelProps> = ({ value, index, children }) => {
  return value === index ? <Box>{children}</Box> : null;
};

interface TabLayoutProps {
  tabs: { label: string; content: (navigateToTab: (index: number) => void) => React.ReactNode; disabled?: boolean }[];
}

const TabLayout: React.FC<TabLayoutProps> = ({ tabs }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const navigateToTab = (index: number) => {
    setValue(index);
  };

  return (
    <div className='tab-style-1'>
      <Tabs value={value} onChange={handleChange} aria-label='dynamic tabs'>
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} disabled={tab.disabled} />
        ))}
      </Tabs>
      <div className='tab-content'>
        {tabs.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            {tab.content(navigateToTab)}
          </TabPanel>
        ))}
      </div>
    </div>
  );
};

export default TabLayout;
